// Pushes events to the GTM dataLayer and remembers first-touch campaign (UTM) params.
const UTM_KEY = "cck_utm_v1";
const UTM_FIELDS = ["utm_source", "utm_medium", "utm_campaign", "utm_term", "utm_content", "gclid", "fbclid"];

export function captureCampaign() {
  try {
    const params = new URLSearchParams(window.location.search);
    const found = {};
    UTM_FIELDS.forEach((k) => { if (params.get(k)) found[k] = params.get(k); });
    if (Object.keys(found).length && !localStorage.getItem(UTM_KEY)) {
      localStorage.setItem(UTM_KEY, JSON.stringify({ ...found, landing_page: window.location.pathname }));
    }
  } catch { /* storage disabled */ }
}

export function getCampaign() {
  try { return JSON.parse(localStorage.getItem(UTM_KEY) || "{}"); } catch { return {}; }
}

const ROLE_BY_PORTAL = {
  "/vendor-portal": "vendor", "/event-creator-portal": "event_creator",
  "/marketplace-portal": "marketplace_user", "/dashboard": "parent", "/admin": "admin",
};

export function trackPayment({ redirect, reference, plan, flow }) {
  const role = ROLE_BY_PORTAL[redirect];
  const key = `cck_gtm_paid_${reference}`;
  try { if (sessionStorage.getItem(key)) return; sessionStorage.setItem(key, "1"); } catch { /* storage disabled */ }
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ event: "payment_complete", user_role: role || "unknown", plan: plan || "unknown", payment_flow: flow, transaction_id: reference, currency: "ZAR", ...getCampaign() });
}

export function trackSignUp(role, method) {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ event: "sign_up", user_role: role || "unknown", signup_method: method, ...getCampaign() });
}
